var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_setup.name))]
          ),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handleClearDatasetItemsCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-eraser",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Clear dataset")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handleDeleteDatasetCommandV1 },
                },
                [
                  _c("i", { staticClass: "fa-regular fa-trash-can" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Delete")]),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handlePermanentDeleteDatasetCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-remove",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Permanently delete")]),
                ]
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", { staticClass: "border-box mb-3 p-4" }, [
          _c("div", { staticClass: "row mb-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-1" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_setup.showApi,
                      expression: "!showApi",
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _setup.showApi = true
                    },
                  },
                },
                [_c("i", { staticClass: "fa-solid fa-chevron-down" })]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _setup.showApi,
                      expression: "showApi",
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _setup.showApi = false
                    },
                  },
                },
                [_c("i", { staticClass: "fa-solid fa-chevron-up" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.showApi,
                  expression: "showApi",
                },
              ],
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("strong", [
                _vm._v(
                  "Authorization: API Key (AccessToken = YOUR_ACCESS_TOKEN)"
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/#/organizations/accesstokens/my",
                    target: "_blank",
                  },
                },
                [_vm._v("My Access Tokens")]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Get all items in dataset")]),
                _c("br"),
                _vm._v(
                  "\n                        GET /integrations/api/datasets/2024-10-24/" +
                    _vm._s(_setup.id) +
                    "/data\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Get signle item from dataset")]),
                _c("br"),
                _vm._v(
                  "\n                        GET /integrations/api/datasets/2024-10-24/" +
                    _vm._s(_setup.id) +
                    "/data/{ID_PROPERTY_NAME}/{ID}\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Add item to dataset")]),
                _c("br"),
                _vm._v(
                  "\n                        POST /integrations/api/datasets/2024-10-24/" +
                    _vm._s(_setup.id) +
                    "/data/{ID_PROPERTY_NAME}/{ID}\n"
                ),
                _c("pre", [
                  _vm._v(
                    '{\n    "Name": "My Project 123",\n    "Description": "My project description"\n}\n'
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Update item in dataset")]),
                _c("br"),
                _vm._v(
                  "\n                        PUT /integrations/api/datasets/2024-10-24/" +
                    _vm._s(_setup.id) +
                    "/data/{ID_PROPERTY_NAME}/{ID}\n"
                ),
                _c("pre", [
                  _vm._v(
                    '{\n    "Description": "My project NEW description"\n}\n'
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Delete item from dataset")]),
                _c("br"),
                _vm._v(
                  "\n                        DELETE /integrations/api/datasets/2024-10-24/" +
                    _vm._s(_setup.id) +
                    "/data/{ID_PROPERTY_NAME}/{ID}\n                    "
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("strong", [_vm._v("Items: " + _vm._s(_setup.data.length))]),
        _vm._v(" "),
        _c("json-viewer", {
          attrs: {
            if: "data",
            value: _setup.data,
            "expand-depth": 1,
            expanded: "",
            copyable: "",
            boxed: "",
            sort: "",
          },
        }),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_setup.changesReversed, function (c) {
            return _c("li", [
              _vm._v("\n                    " + _vm._s(c.Details) + " "),
              _c(
                "a",
                {
                  attrs: {
                    href: `/#/admin/integrations/runs/details/${_setup.tid}/${c.RunId}`,
                  },
                },
                [_vm._v("Run")]
              ),
            ])
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-11" }, [
      _c("h5", { staticClass: "m-0" }, [_vm._v("REST API")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }